{
  "title": "Warding Wind",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "2nd-level evocation",
  "level": 2,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "A strong wind (20 miles per hour) blows around you in a 10-foot radius and moves with you, remaining centered on you. The wind lasts for the spell’s duration.",
    "The wind has the following effects:",
    "It deafens you and other creatures in its area.",
    "It extinguishes unprotected flames in its area that are torch-sized or smaller.",
    "The area is difficult terrain for creatures other than you.",
    "The attack rolls of ranged weapon attacks have disadvantage if they pass in or out of the wind.",
    "It hedges out vapor, gas, and fog that can be dispersed by strong wind."
  ],
  "spellLists": ["bard", "druid", "eldritch-knight", "sorcerer", "wizard"]
}
